import { useState, useEffect } from 'react';
import { Stack, Box, CircularProgress } from '@mui/material';
import Chips from '../chips.component';
import RegulationItemUpdatedOn from './regulation-item-updatedOn.component';
import { getAuthToken, RegulationService } from '../../service';
import { useMsal } from '@azure/msal-react';
import { ResultType } from '../../utils/custom.ResultTypeMonths';

const RegulationListUpdateOn = ({ regulationSeeUpDate, onChipDelete, chipLabel }) => {
    // Variables for utility functions
    const [isLoading, setIsLoading] = useState(true);
    const [resultTypeSelected, setResultTypeSelected] = useState('');
    const [currentPageData, setCurrentPageData] = useState();
    const { instance, accounts } = useMsal();

    useEffect(() => {
        (async () => {
            setIsLoading(true);
            await handleSeeUpdateClick();
            setIsLoading(false);
        })();
    }, [resultTypeSelected]);

    useEffect(() => {
        setIsLoading(true);
        setCurrentPageData(regulationSeeUpDate);
        setIsLoading(false);
    }, [regulationSeeUpDate]);

    const handleSeeUpdateClick = async () => {
        // Reset Pin and Subject
        const authToken = await getAuthToken(instance, accounts);
        const data = await RegulationService.getSeeUpdate(authToken, resultTypeSelected === ResultType.sixMonths ? 6 : 3);
        if (!data) {
            console.error('Error: Getting WorldWide data.');
            return;
        }

        setCurrentPageData(data);
    };

    const handleResultTypeChange = (event) => {
        setResultTypeSelected(event.target.value);
    };

    const handleChipDelete = () => {
        onChipDelete();
    };

    const getChipLabel = () => {
        return [
            {
                name: chipLabel
            }
        ];
    };

    return (
        <>
            {isLoading ? (
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <CircularProgress size={100} />
                </Box>
            ) : (
                currentPageData && (
                    <Stack direction={'column'}>
                        <Chips sx={{ width: { xs: '200px', sm: '200px', md: '200px' } }} handleChipDelete={handleChipDelete} filters={getChipLabel()} />
                        <RegulationItemUpdatedOn regulationData={currentPageData} resultTypeSelected={resultTypeSelected} onResultTypeChange={handleResultTypeChange} />
                    </Stack>
                )
            )}
        </>
    );
};

export default RegulationListUpdateOn;
